/* eslint-disable jira/filename-case */
export const DEFAULT_METRICS_HISTOGRAM = '1000_1500_2000_2500_3000_4000';

export const BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION = '2QE2xWf0TpDbYpk4oY9aQr';
export const BOARD_SETTINGS_ARTICLE_SAC_URL_CONFIG_DISABLE_SECTION =
	'https://support.atlassian.com/jira-software-cloud/docs/how-do-jira-permissions-work/';
export const BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID: '2QE2xWf0TpDbYpk4oY9aQr.config-disabled-section.article.analytics' = `${BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION}.config-disabled-section.article.analytics`;

export const DEFAULT_LEVEL_ONE_NAME = 'Epic';

const INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
	'cardColors',
	'cardLayout',
	'columns',
	'default',
	'estimation',
	'filter',
	'swimlanes',
	'time',
	'timelineConfig',
	'quickFilters',
	'dateFields',
] as const;

export const BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES: Set<string> = new Set<string>(
	INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES,
);

export type ConfigParamKey = (typeof INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES)[number];

// oxlint-disable-next-line typescript/consistent-type-assertions
export const boardSettingsQueryConfigParamValues = Object.fromEntries(
	INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key) => [key, key]),
) as { [K in ConfigParamKey]: K };

type JsmFeatureEnabled = {
	isCalendarEnabled: boolean;
	isBoardEnabled: boolean;
};

type JsmFeatureVisible = (features: JsmFeatureEnabled) => boolean;

type Config = {
	configQuery: ConfigParamKey;
	userLocatedBoardAllowed: boolean;
	kanbanAllowed: boolean;
	isJsmFeatureVisible: JsmFeatureVisible;
	jswAllowed: boolean;
};

export const SETTINGS_CONFIG: Record<ConfigParamKey, Config> = {
	default: {
		configQuery: boardSettingsQueryConfigParamValues.filter,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isCalendarEnabled, isBoardEnabled }) =>
			isCalendarEnabled || isBoardEnabled,
		jswAllowed: true,
	},
	filter: {
		configQuery: boardSettingsQueryConfigParamValues.filter,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isCalendarEnabled, isBoardEnabled }) =>
			isCalendarEnabled || isBoardEnabled,
		jswAllowed: true,
	},
	columns: {
		configQuery: boardSettingsQueryConfigParamValues.columns,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isBoardEnabled }) => isBoardEnabled,
		jswAllowed: true,
	},
	swimlanes: {
		configQuery: boardSettingsQueryConfigParamValues.swimlanes,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isBoardEnabled }) => isBoardEnabled,
		jswAllowed: true,
	},
	quickFilters: {
		configQuery: boardSettingsQueryConfigParamValues.quickFilters,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isBoardEnabled }) => isBoardEnabled,
		jswAllowed: true,
	},
	cardColors: {
		configQuery: boardSettingsQueryConfigParamValues.cardColors,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isBoardEnabled }) => isBoardEnabled,
		jswAllowed: true,
	},
	cardLayout: {
		configQuery: boardSettingsQueryConfigParamValues.cardLayout,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isBoardEnabled }) => isBoardEnabled,
		jswAllowed: true,
	},
	estimation: {
		configQuery: boardSettingsQueryConfigParamValues.estimation,
		userLocatedBoardAllowed: true,
		kanbanAllowed: false,
		isJsmFeatureVisible: () => false,
		jswAllowed: true,
	},
	time: {
		configQuery: boardSettingsQueryConfigParamValues.time,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: () => false,
		jswAllowed: true,
	},
	timelineConfig: {
		configQuery: boardSettingsQueryConfigParamValues.timelineConfig,
		userLocatedBoardAllowed: false,
		kanbanAllowed: true,
		isJsmFeatureVisible: () => false,
		jswAllowed: true,
	},
	dateFields: {
		configQuery: boardSettingsQueryConfigParamValues.dateFields,
		userLocatedBoardAllowed: true,
		kanbanAllowed: true,
		isJsmFeatureVisible: ({ isCalendarEnabled }) => isCalendarEnabled,
		jswAllowed: false,
	},
} as const;

export const HEAVY_TEST_TIMEOUT = 60000;

// oxlint-disable-next-line typescript/consistent-type-assertions
export const EDIT_BOARD_CONFIG = 'EDIT_BOARD_CONFIG' as unknown as AGG$SoftwareBoardPermission;
export const ADMINISTER_PARENT_PROJECT =
	// oxlint-disable-next-line typescript/consistent-type-assertions
	'ADMINISTER_PARENT_PROJECT' as unknown as AGG$SoftwareBoardPermission;
export const USER_PICKER_PROJECT_PERMISSION_KEY =
	// oxlint-disable-next-line typescript/consistent-type-assertions
	'USER_PICKER' as unknown as AGG$SoftwareBoardPermission;
export const ADMINISTER_PROJECT_PERMISSION_KEY = 'ADMINISTER';

// oxlint-disable-next-line typescript/consistent-type-assertions
export const BACKLOG_FEATURE_KEY = 'BACKLOG' as unknown as AGG$SoftwareBoardFeatureKey;
// oxlint-disable-next-line typescript/consistent-type-assertions
export const SPRINTS_FEATURE_KEY = 'SPRINTS' as unknown as AGG$SoftwareBoardFeatureKey;

export const FEATURE_ENABLED_STATUS = 'ENABLED';
